import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useStaffMemberReference = create((set) => ({
  referenceLoading: false,
  reference: [],
  pagination: {
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },

  // Function to reset currentPage only when an action happens
  resetCurrentPage: () => {
    set((state) => ({
      pagination: {
        ...state.pagination,
        currentPage: 1,
      },
    }));
  },

  // Function to get references
  getReference: async ({ id, query = null, successCallback }) => {
    set({ referenceLoading: true });
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_CAREGIVER_REFERENCE,
        null,
        query,
        id
      );

      if (response.success) {
        set({
          reference: response.data?.data || [],
          pagination: {
            pageSize: response.data?.pagination?.limit,
            totalItems: response.data?.pagination?.total,
            currentPage: response.data?.pagination?.page,
            totalPages: response.data?.pagination?.totalPages,
          },
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      set({ referenceLoading: false });
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to add the reference
  addReference: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.ADD_CAREGIVER_REFERENCE,
        data
      );

      if (response.success) {
        await useStaffMemberReference.getState().getReference({
          id: data.userId,
          successCallback: () => {
            useStaffMemberReference.getState().resetCurrentPage(); // Reset page
            successCallback && successCallback(response);
          },
        });
      }
      // if (response.success) {
      //   set((state) => {
      //     const updatedReferences = [response.data?.data, ...state.reference];
      //     const updatedTotalItems = updatedReferences.length;
      //     const updatedTotalPages = Math.ceil(
      //       updatedTotalItems / state.pagination.pageSize
      //     );
      //     return {
      //       reference: updatedReferences,
      //       pagination: {
      //         ...state.pagination,
      //         totalItems: updatedTotalItems,
      //         totalPages: updatedTotalPages,
      //       },
      //     };
      //   });
      //   successCallback && successCallback(response);
      // }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to override the phone reference
  referencePhoneOverride: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.REFERENCE_PHONE_OVERRIDE,
        data,
        null,
        id
      );

      if (response.success) {
        set((state) => ({
          reference: state.reference.map((item) =>
            item.id === id ? { ...item, ...response?.data } : item
          ),
        }));

        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to send reminder
  referenceSendReminder: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.REFERENCE_SEND_REMINDER,
        data
      );

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to cancel the request
  referenceCancelRequest: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.REFERENCE_CANCEL_REQUEST,
        data,
        null,
        id
      );

      if (response.success) {
        set((state) => ({
          reference: state.reference.map((item) =>
            item.id === id ? { ...item, ...response?.data?.data } : item
          ),
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useStaffMemberReference;
